import Levenshtein from 'fast-levenshtein';
import _ from 'lodash';
import { convertViewModelDataToJson } from 'shared/view/service-details-conversion-service';
import request from 'shared/helper/request';
import * as c from './constants';
var JOURNAL_API_ENDPOINT = '//api.crossref.org/journals';
var currentServiceIdentities = null;
export var loadServiceDetails = function loadServiceDetails(serviceIdentities) {
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    if (_.isEqual(currentServiceIdentities, serviceIdentities)) {
      return new Promise(function (resolve) {
        return resolve();
      });
    }
    currentServiceIdentities = serviceIdentities;
    return dispatch(application.get('/api/service-details', {
      serviceIdentities: serviceIdentities
    })).then(function (json) {
      var _convertViewModelData = convertViewModelDataToJson(json),
        fileTypes = _convertViewModelData.fileTypes,
        journalDetails = _convertViewModelData.journalDetails,
        questions = _convertViewModelData.questions,
        questionsRequiringPreviousSelection = _convertViewModelData.questionsRequiringPreviousSelection;
      dispatch({
        type: c.SERVICE_DETAILS_UPDATED,
        fileTypes: fileTypes,
        journalDetails: journalDetails,
        questionsRequiringPreviousSelection: questionsRequiringPreviousSelection,
        questions: questions
      });
      return {
        journalDetails: journalDetails,
        questions: questions
      };
    });
  };
};
export var clearServiceDetails = function clearServiceDetails() {
  currentServiceIdentities = null;
  return {
    type: c.SERVICE_DETAILS_CLEARED
  };
};
export var fetchJournals = function fetchJournals(journalName) {
  return function () {
    return new Promise(function (resolve) {
      request.req({
        method: 'get',
        url: "".concat(JOURNAL_API_ENDPOINT, "?query=").concat(journalName.toLowerCase()),
        withCredentials: false,
        headers: {}
      }).then(function (json) {
        var options = json.message.items.map(function (item) {
          return {
            journal: item,
            label: item.title,
            value: item.title,
            // Calculate the Levenshtein distance between the
            // journal's name and the user's query. The closest
            // match is the title with the lowest value.
            match: Levenshtein.get(item.title.toLowerCase(), journalName.toLowerCase())
          };
        }).sort(function (a, b) {
          return a.match - b.match;
        }).slice(0, 10);
        resolve(options);
      }).catch(function () {
        return resolve([]);
      });
    });
  };
};
export var fetchJournalDetails = function fetchJournalDetails(journal) {
  return function () {
    return new Promise(function (resolve) {
      return request.req({
        method: 'get',
        url: "https://doaj.org/api/v2/search/journals/issn:".concat(journal.ISSN[0]),
        withCredentials: false,
        headers: {}
      }).then(function (json) {
        var foundJournal = json.results.find(function (result) {
          return result.bibjson.title === journal.title;
        });
        if (!foundJournal) {
          resolve({
            url: ''
          });
        }
        var url = foundJournal.bibjson.ref && foundJournal.bibjson.ref.journal ? foundJournal.bibjson.ref.journal : '';
        resolve({
          url: url
        });
      }).catch(function () {
        return resolve({
          url: ''
        });
      });
    });
  };
};